<template>
  <iframe style="border: none;"
          :height="iframeHeight"
          v-bind="$attrs"
          @on="$listeners"
          ref="iframe"
          @load="onIframeLoad"></iframe>
</template>

<script>
  export default {
    name: 'IframeResize',
    data(vm) {
      let height = parseFloat(vm.$attrs.height)
      height = height > 100 ? height : 484

      return {
        minIframeHeight: height,
        maxIframeHeight: 4000,
        iframeHeight: height > 100 ? height : 484,
      }
    },
    methods: {
      onIframeLoad(event) {
        this.$emit('load', event)
        // setTimeout(() => {
        //   window.postMessage({
        //     type: 'scroll-to',
        //     data: {
        //       scroll: 0
        //     }
        //   }, 'http://localhost:8080/')
        // }, 2000)

        window.addEventListener('message', (event) => {
          const data = event.data
          if (typeof data !== 'object') {
            return
          }

          switch (data.type) {
            case 'iframe-resize': {
              let scrollHeight = data.data.scrollHeight

              if (scrollHeight < this.minIframeHeight) {
                scrollHeight = this.minIframeHeight
              }

              if (scrollHeight > this.maxIframeHeight) {
                scrollHeight = this.maxIframeHeight
              }

              this.iframeHeight = scrollHeight

              return
            }

            case 'scroll-top': {
              this.$scrollTo(document.body)
              return
            }
          }
        })
      },
    }
  }
</script>

<style lang="less">

</style>
